import Button from "../UI/Button";

// Fungsi untuk mendeteksi apakah file adalah video (dari URL, nama, atau tipe MIME)
const isVideoFile = (file) => {
  if (!file) return false;
  
  // Jika file memiliki tipe MIME (biasanya file yang baru di-select dari komputer)
  if (file.type && file.type.startsWith("video/")) return true;

  // Cek dari ekstensi di URL atau Nama
  const urlOrName = file.url || file.name || "";
  const cleanString = urlOrName.split("?")[0].toLowerCase();
  const videoExtensions = [".mp4", ".webm", ".mov", ".ogg"];
  
  return videoExtensions.some(ext => cleanString.endsWith(ext));
};

const MediaUploader = ({ files = [], onUpload, onRemove }) => {
  const handleChange = (e) => {
    const selectedFiles = Array.from(e.target.files || []);
    if (onUpload) onUpload(selectedFiles);
  };

  return (
    <div className="admin-media-uploader" style={{ padding: "20px 0" }}>
      <label className="admin-upload-box" style={{ 
        border: "2px dashed #d1d5db", 
        padding: "40px", 
        display: "block", 
        textAlign: "center", 
        borderRadius: "12px", 
        cursor: "pointer",
        backgroundColor: "#f9fafb",
        marginBottom: "30px",
        transition: "background-color 0.2s"
      }}>
        <input 
          type="file" 
          multiple 
          accept="image/*,video/mp4,video/webm,video/ogg" // Tambahkan accept agar browser tahu bisa terima video
          onChange={handleChange} 
          style={{ display: "none" }} 
        />
        <div className="admin-upload-box__content">
          <div style={{ fontSize: "40px" }}>📁</div>
          <h3 style={{ margin: "10px 0", color: "#111827" }}>Upload Gambar / Video</h3>
          <p style={{ color: "#6b7280", marginBottom: "5px" }}>Pilih satu atau beberapa file untuk diunggah ke galeri media.</p>
          <span style={{ color: "#16a34a", fontWeight: "600" }}>Klik area ini untuk memilih file</span>
        </div>
      </label>

      {files.length > 0 && (
        <div style={{ 
          display: "grid", 
          gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", 
          gap: "20px",
          width: "100%" 
        }}>
          {files.map((file, index) => {
            const isVideo = isVideoFile(file);

            return (
              <div key={file.id || index} style={{ 
                border: "1px solid #e5e7eb", 
                borderRadius: "10px", 
                overflow: "hidden", 
                backgroundColor: "#fff",
                boxShadow: "0 2px 4px rgba(0,0,0,0.02)"
              }}>
                <div style={{ width: "100%", height: "150px", backgroundColor: "#000", position: "relative" }}>
                  {file.url ? (
                    isVideo ? (
                      <>
                        {/* Ikon Play Mini untuk penanda Video */}
                        <div style={{
                          position: "absolute",
                          top: "50%", left: "50%", transform: "translate(-50%, -50%)",
                          backgroundColor: "rgba(0,0,0,0.6)", color: "#fff",
                          width: "36px", height: "36px", borderRadius: "50%",
                          display: "flex", alignItems: "center", justifyContent: "center",
                          fontSize: "14px", zIndex: 2, border: "2px solid #fff"
                        }}>
                          ▶
                        </div>
                        {/* Trik preload metadata dan #t=0.1 agar muncul frame gambarnya */}
                        <video 
                          src={`${file.url}#t=0.1`} 
                          style={{ width: "100%", height: "100%", objectFit: "cover" }} 
                          muted 
                          playsInline 
                          preload="metadata"
                        />
                      </>
                    ) : (
                      <img 
                        src={file.url} 
                        alt={file.name} 
                        style={{ width: "100%", height: "100%", objectFit: "cover" }} 
                      />
                    )
                  ) : (
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", height: "100%", fontSize: "30px", backgroundColor: "#f3f4f6" }}>
                      {isVideo ? "🎬" : "🖼️"}
                    </div>
                  )}
                </div>
                
                <div style={{ padding: "12px" }}>
                  <strong style={{ fontSize: "14px", display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", color: "#111827" }}>
                    {isVideo ? "📹 " : "📷 "}{file.name}
                  </strong>
                  <p style={{ fontSize: "12px", color: "#6b7280", margin: "4px 0 10px" }}>
                    {file.size} {file.category ? `• ${file.category}` : ""}
                  </p>
                  <Button size="sm" variant="danger" onClick={() => onRemove && onRemove(file, index)} style={{ width: "100%" }}>
                    Hapus
                  </Button>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default MediaUploader;